import 'CssFolder/components/select-input-component.scss';
import { Callout, Dialog, Icon, Icons, Intent, Spinner, Tag } from "construct-ui";
import codeMasterModel from "../../models/common/code-master.model";
import languageModel from "../../models/language.model";
import ViewBase from "../../views/view-base.view";
import QueryListComponent from "../query-list/query-list.component";
import campaignModel from '../../models/planogram/campaign.model';
export default function CodeByCategorySelectionComponent() {
    ViewBase.call(this);

    const TITLE_SEPARATOR = ', ';

    const STYLE_MIN_HEIGHT = '300px';

    const DEFAULT_ITEM_KEY = 'code';
    const DEFAULT_ITEM_VALUE = 'name';
    const DEFAULT_PAGE_INDEX = 1;
    const DEFAULT_PAGE_SIZE = 200;
    const DEFAULT_SEARCH_TEXT = '';
    const DEFAULT_ICON = Icons.LIST;
    const DEFAULT_TITLE = 'Code Master Input Component';
    const DEFAULT_SEARCH_PLACEHOLDER_TEXT = 'Search';

    const DEFAULT_ONSELECT = (selectedItems) => { console.log('QueryListInputComponent: onSelect(selectedItems)'); }
    const DEFAULT_ONINFINITESCROLL = (searchText, pageIndex, pageSize) => { console.log('QueryListInputComponent: onInfiniteScroll(searchText, pageIndex, pageSize)'); }

    let items = [];
    let category = '';
    let isDialogOpen = false;
    let searchText = DEFAULT_SEARCH_TEXT;
    let pageIndex = DEFAULT_PAGE_INDEX;
    let isSearching = false;

    const openDialog = () => {
        isDialogOpen = true;
    }

    const closeDialog = () => {
        isDialogOpen = false;
    }

    const renderLabel = (selectedItems, key, value) => {
        if (selectedItems?.length > 0) {
            if (selectedItems.length <= 3) {
                return selectedItems.map(item => item[value] || item[key]).join(', ');
            }

            return `${selectedItems.length} ${languageModel.getText("LT00000308", "items selected")}`;
        }
        return '';
    }

    const renderTitle = (selectedItems, key, value) => {
        if (selectedItems?.length > 0) {
            return selectedItems.map(item => item[value] || item[key]).join(TITLE_SEPARATOR);
        }

        return '';
    }

    const onRemove = (selectedItems, item, onSelect, key) => () => {
        const result = structuredClone(selectedItems);
        const itemIndex = result.findIndex((e) => e[key] === item[key]);
        result.splice(itemIndex, 1);
        onSelect(result);
    };

    const onClear = (onSelect) => () => {
        onSelect([]);
    }

    const onReset = () => {
        searchText = DEFAULT_SEARCH_TEXT;
        pageIndex = DEFAULT_PAGE_INDEX;
    }


    const onSearch = (searchText, pageIndex, pageSize) => {
        isSearching = true;
        if (category == 'fixture') {
            campaignModel.getFixtures({ fixtureName: searchText, pageIndex, pageSize, status: 1 }).then((result) => {
                items = result;
            })
                .catch((error) => {
                    this.handleError(error);
                })
                .finally(() => {
                    isSearching = false;
                })
        } else {
            codeMasterModel.searchByCategoryV2(category, { value: searchText, pageIndex, pageSize })
                .then((result) => {
                    items = result;
                })
                .catch((error) => {
                    this.handleError(error);
                })
                .finally(() => {
                    isSearching = false;
                })
        }
    }

    const readOnly = (event) => {
        event.preventDefault();
        event.stopPropagation();
    }

    return {
        oninit: (vnode) => {
            if (vnode.attrs.category) {
                category = vnode.attrs.category;
            }
            onSearch();
        },
        view: ({ attrs: { selectedItems = [], totalItemsCount = 0, pageSize = DEFAULT_PAGE_SIZE, itemKey = DEFAULT_ITEM_KEY, itemValue = DEFAULT_ITEM_VALUE,
            title = DEFAULT_TITLE, required = false, multiple = true, icon = DEFAULT_ICON, searchPlaceholderText = DEFAULT_SEARCH_PLACEHOLDER_TEXT,
            onSelect = DEFAULT_ONSELECT, onInfiniteScroll = DEFAULT_ONINFINITESCROLL } }) => [
                m('.select-input-component.d-flex.gap-4.justify-content-between.align-items-center.form-control.form-control-bg.cursor-pointer', { onclick: openDialog },
                    m('input.flex-fill.text-start.ps-0', {
                        type: 'text',
                        style: {
                            width: 'inherit',
                            'overflow-x': 'hidden',
                            'text-overflow': 'ellipsis',
                            border: 'none',
                            background: 'transparent'
                        },
                        oninput: readOnly,
                        autocomplete: 'off',
                        placeholder: languageModel.getText("LT00000719", "No items selected"),
                        title: renderTitle(selectedItems, itemKey, itemValue),
                        value: renderLabel(selectedItems, itemKey, itemValue),
                        required
                    }),
                    m(Icon,
                        {
                            name: icon,
                            intent: Intent.PRIMARY,
                            onclick: openDialog
                        }
                    )
                ),
                m(Dialog,
                    {
                        title,
                        class: 'cui-dialog-l',
                        closeOnOutsideClick: false,
                        isOpen: isDialogOpen,
                        onClose: closeDialog,
                        content: m('.d-flex.flex-column.gap-3',
                            m('div',
                                m('.d-flex.justify-content-between.mb-1',
                                    m('span', `${languageModel.getText("LT00000346", "Selected items")}: ${Array.isArray(selectedItems) ? selectedItems.length : 0}`),
                                    m('a.btn.btn-link.p-0', { onclick: onClear(onSelect) }, languageModel.getText("LT00000345", "Clear all"))
                                ),
                                m('.card',
                                    m('.card-body',
                                        selectedItems.length === 0
                                            ? m('.text-center', m('small.text-muted', languageModel.getText("LT00000318", "No items selected. Please search and select from the section below.")))
                                            : selectedItems.map(item => m(Tag, {
                                                label: item.name,
                                                onRemove: onRemove(selectedItems, item, onSelect, itemKey)
                                            }))
                                    )
                                )
                            ),
                            m('.card', { style: { 'min-height': STYLE_MIN_HEIGHT }, },
                                m('.card-body',
                                    m('form.d-flex.gap-2.mb-2', {
                                        onsubmit: (e) => {
                                            e.preventDefault();
                                            onSearch(searchText, pageIndex, pageSize);
                                        }
                                    },
                                        m('input.flex-fill.form-control.form-control-bg', {
                                            type: 'text',
                                            value: searchText,
                                            placeholder: searchPlaceholderText,
                                            onchange: (e) => { searchText = e.target.value; }
                                        }),
                                        m('button.btn.btn-primary', { disabled: isSearching }, languageModel.getText('LT00000001', 'Search')),
                                        m('button.btn.btn-white', { onclick: onReset }, languageModel.getText('LT00000031', 'Clear'))

                                    ),
                                    m('p.text-danger.ps-4', { style: 'font-size: 12px' }, this.getText('LT00000901', '*use comma for multi search (ex: C0001,C0002)')),
                                    isSearching
                                        ? m(Spinner, { fill: true, background: true, active: isSearching })
                                        : m('div',
                                            m(QueryListComponent, {
                                                filterable: false,
                                                multiple: multiple,
                                                items,
                                                selectedItems,
                                                onSelect,
                                                onInfiniteScroll: () => {
                                                    onInfiniteScroll(searchText, ++pageIndex, pageSize);
                                                }
                                            }),
                                            totalItemsCount > 0 &&
                                            totalItemsCount > items.length &&
                                            m('div.text-end',
                                                m('small', `${selectedItems.length > 0 ? selectedItems.length : '0'} / ${totalItemsCount} ${languageModel.getText('LT00000364', 'record(s)')}`)
                                            )
                                        ),
                                    items && items.length > 199 &&
                                    m(Callout, {
                                        content: this.getText("LT00000320", "Only top 200 records are shown due to large result set"),
                                        icon: Icons.ALERT_CIRCLE,
                                        intent: Intent.WARNING,
                                    })
                                )
                            )
                        ),
                        footer: m('.hstack.justify-content-end',
                            m('button.btn.btn-white', { onclick: closeDialog }, languageModel.getText('LT00000021', 'Close'))
                        )
                    }
                )
            ]
    }
}